module.exports = __webpack_public_path__ + "static/media/guarantee.66079c9a.png";